import React, {Component} from 'react';
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";

export default class MiesieczneTableStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status:null,
        };
        this.onChangeStatus=this.onChangeStatus.bind(this)
    }

    componentDidMount(){
        this.ustawStatus(this.props)
    }

    componentWillReceiveProps(nextprops){
        this.ustawStatus(nextprops)
    }

    ustawStatus(props){
        this.setState({status:props.status})
    }

    onChangeStatus(e) {

        if(this.props.status.value == 1 && e.value == -1){
            alert('Nie można zmienić statusu z "opłacony" na "do opłaty"!')
        }else{
            this.props.handleChangeStatus(e)
            this.setState({status: e})
        }
    }

    renderStatusBiletu(option){
        return <div style={{fontWeight:'bold', color:option.kolor}}><i className={option.ikona} style={{marginRight:'5px'}}></i> {option.label}</div>
    }


    render() {

        return (
            <div>
                <TopSelect onChange={this.onChangeStatus} value={this.state.status} options={this.props.statusy} clearable={false}
                           valueRenderer={this.renderStatusBiletu} optionRenderer={this.renderStatusBiletu}
                           disabled={this.props.disableSelect? true: ((this.props.status)?this.props.status.value == -2:false)}

                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyMiesieczne/components/MiesieczneTableStatus.js